import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addRequest,
  changeStatus,
  fetchContactedRequests,
  fetchPendingRequests,
} from "../../slices/tourRequestSlice";
import * as signalR from "@microsoft/signalr";
import "../../Static Files/styles/request/request.css";

const TourRequests = () => {
  const dispatch = useDispatch();
  const { contactedRequests, pendingRequests } = useSelector(
    (state) => state.requests
  );
  const { userInfo } = useSelector((state) => state.users);
  const [importedRequest, setImportedRequest] = useState([]);
  const [isContacted, setIsContacted] = useState(true);

  useEffect(() => {
    dispatch(fetchPendingRequests());
  }, [dispatch]);

  useEffect(() => {
    setImportedRequest(pendingRequests); // pendingRequests yüklənəndə, table-i doldur
  }, [pendingRequests]);

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl("https://localhost:7089/tourRequestHub", {
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then()
      .catch((err) => console.error("SignalR failed", err));

    connection.on("ReceiveTourRequest", (name, email, phone,tourId) => {
      dispatch(fetchPendingRequests());
    });
  }, [dispatch]);

  const pending = () => {
    dispatch(fetchPendingRequests());
    setIsContacted(true);
    setImportedRequest(pendingRequests);
  };

  const contacted = () => {
    dispatch(fetchContactedRequests());
    setIsContacted(false);
    setImportedRequest(contactedRequests);
  };

  const ChangeStatus = (tourRequestId,adminEmail) => {
    console.log(tourRequestId);
    dispatch(changeStatus(tourRequestId,adminEmail));
    setImportedRequest(pendingRequests);
  };

  return (
    <>
      <section className="requests-section">
        <div className="top">
          <ul className="users-card-list">
            <li>
              <a onClick={() => contacted()} href="#">
                Cavab verilənlər
              </a>
            </li>
            <li>
              <a onClick={() => pending()} href="#">
                Gözləmədə olanlar
              </a>
            </li>
          </ul>
        </div>

        {/* Scroll olacaq div */}
        <div className="table-container">
          <table
            className="tab-requests"
            border="1"
            style={{ width: "100%", textAlign: "left" }}
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>Ad</th>
                <th>Email</th>
                <th>Telefon nomresi</th>
                <th>Turun ID si</th>
                <th>Status</th>
                {isContacted === false && <th>Cavab verilmə vaxtı</th>}
                {isContacted === false && <th>Əlaqədar əməkdaş</th>}
                {isContacted && <th>Əməliyyatlar</th>}
              </tr>
            </thead>
            <tbody>
              {importedRequest.map((request) => (
                <tr key={request.id}>
                  <td>{request.id}</td>
                  <td>{request.name}</td>
                  <td>{request.email}</td>
                  <td>{request.phone}</td>
                  <td>{request.tourId}</td>
                  <td>{request.status}</td>
                  {isContacted === false && <td>{request.contactedDate.split(" ")[0]}</td>}
                  {isContacted === false && (
                    <td>{request.adminEmail}</td>
                  )}
                  {isContacted && (
                    <td>
                      <button
                        onClick={() => ChangeStatus(request.id, userInfo?.email)}
                        className="operation-button"
                      >
                        Statusu deyiş
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default TourRequests;
